import React from 'react';
import {
  makeStyles,
  mergeClasses,
  Divider,
  OverflowDivider,
} from '@fluentui/react-components';
import { SideNavigationDividerProps } from './types';

const useStyles = makeStyles({
  container: {
    flexGrow: 0,
    height: '9px',
  },
});

export const SideNavigationGroupDivider : React.FC<SideNavigationDividerProps> = ({
  groupId,
  id,
  className,
}) => {
  const classes = useStyles();

  return (
    <OverflowDivider
      key={`key_${id}`}
      groupId={groupId}
    >
      <Divider
        id={id}
        inset
        className={mergeClasses(classes.container, className)}
      />
    </OverflowDivider>
  );
};
